<template>
   <palletinfodashboard>
  <div class="animated fadeIn">

    <b-row>
      <b-col lg="12">
      <!--  <b-breadcrumb :items="breadcrumbs"/>   -->  
       <b-card header-tag="header" footer-tag="footer">
      
          <b-row class="form-group">
                       <b-col sm="3">
                        <div id='container' >
        <br>     
<ejs-multiselect id='multiselect' placeholder="Select State" v-model="value6" 
:dataSource='stateoptions'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All" :fields='flowfields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
></ejs-multiselect>
          </div>

 

               </b-col>
                <!--  <b-col sm="3" style="margin-top:2%">
                <b-form-group label="Pickup Type:"  :label-cols="6" >
                 <b-form-select name="editpickuptype" v-model="editpickuptype" :class="{'input': true, 'is-invalid': errors.has('form-1.status') }">
                          <option value="">--Select--</option>

                          <option value="3PL">3PL</option>
                          <option value="FC">FC</option>


                        </b-form-select>
                </b-form-group>
              </b-col> -->

              <b-col sm="2" style="margin-top:2%">
               <b-form-group >
                  
                    <b-form-input   v-model="searching" placeholder="Type to Search"></b-form-input>
                   
                     
                </b-form-group>
                
              </b-col>
                <b-col sm="3" >
                  <div class="bt_group">
                      <b-button style=""   variant="primary"@click="displaydata(1);"> Search</b-button> 
                    <b-button     style="margin: 15px" size="md" variant="primary"
                    @click=" clear();">Clear</b-button>
                  </div>

                      </b-col>   
               </b-row>

              <div id="overlay" >
             <div class="loader"></div>
           </div>
          <b-row class="mb-4">  
           <b-col sm="12">
            <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
             <b-button v-if="this.totalRows >0"  variant="primary" size="md" @click="downloadCSV">Download </b-button>

                 
              </b-col>        
        </b-row>


              <b-table  v-if="this.totalRows > 0" style="text-align: left" show-empty stacked="md"  :items="items" :busy="isBusy"    :current-page="currentPage"  :fields="fields" :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div> 
              <template slot="ridername" slot-scope="row">
             {{row.item.deliveryagentfirstname}} {{row.item.deliveryagentlastname}}
            </template> 
        
          </b-table>
           <!-- <div class="table-responsive" >
            <table class="table table-striped table-bordered" border="1" v-if="this.totalRows > 0" >
              <thead style="text-align: left" >
                <tr>
                  <th>Rider Name</th>
                  <th>Shipping Id</th>
                  <th>Status</th>
                  <th>Shipment Status</th>
                  <th>Order Flow</th>
                  <th>Pick up Address</th>
                  <th>Shipping Address</th>
                  <th>Shipping City</th>
                  <th>Locality Name</th>
               
                </tr>
              </thead>
              <tbody>
                <tr>
                  
                <td>{{ ridername }}</td>
                <td>{{ shippingid }}</td>
                <td>{{ deliverystatus }}</td>
                <td>{{ shipmentstatus }}</td>
                <td>{{ orderflow }}</td>
                <td>{{ pickuplocationaddress }}</td>
                <td>{{ shipaddress1 }}</td>
                <td>{{ locality_city_name }}</td>
                <td>{{ locality_name }}</td>
                  
                </tr>
              </tbody>
            </table>
          </div> -->
            

                    
                    <b-col md="12" class="my-1 " v-if="this.totalRows > 10" >
          <!--   <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              >
            </b-pagination> -->
              <paginate
   
    :page-count="noofpages"
    :page-range="10"
    :margin-pages="2"
    :click-handler="clickCallback"
    :prev-text="'Prev'"
    :next-text="'Next'"
    :container-class="'pagination'"
    :page-class="'page-item'">
  </paginate>
          </b-col> 
      


       
       </b-card>
        
      </b-col>
    </b-row><!--/.row-->

  </div>
   </palletinfodashboard>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Filters from '@/utils/filters'
import Utils from '@/utils'
import { EventBus } from "./event-bus.js";
export default {
  mounted() {  
    
      EventBus.$on("clicked-event", pid=> {  
  
  this.displaydata(); 
      });  
   }  ,
  data: function() {
    return {
      name: 'rtslisting',
      data: [],
       records:[],
      items:[],
       fields: [
        { key: 'shippingid', label: 'Shipment ID', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'poid', label: 'POID', sortable: true, sortDirection: 'desc' },
          { key: 'rts_date', label: 'RTS Date', sortable: true, sortDirection: 'desc' },
            { key: 'ageing', label: 'Ageing', sortable: true, sortDirection: 'desc' },
          { key: 'emirates', label: 'Emirats (Ship state name)', sortable: true, sortDirection: 'desc' },
          { key: 'ship_address', label: 'Ship address', sortable: true, sortDirection: 'desc' },
          { key: 'locality_name', label: 'Locality Name', sortable: true, sortDirection: 'desc' },
          { key: 'orderdate', label: 'Confirmation Date', sortable: true, sortDirection: 'desc' },
         
         
          
          
         ], 
      headinglength:0,
      searching:'',
       showSelectAll : true,
      isBusy: false,
       page:1,
      ridername:'', 
      shippingid:'', 
      deliverystatus:'', 
      shipmentstatus:'', 
       orderflow:'', 
       pickuplocationaddress:'', 
       shipaddress1:'', 
      locality_city_name:'',
      locality_name:'', 
       value6:[],


      statenamelist:[],
      stateoptions:[],
      allowCustomValue : true,
      flowfields : {  text: 'name', value: 'id' },
     
      bordered: true,
       disabled: '',
      totalRows: 0,
      itemsperpages:5,
      currentPage: 1,
      customer:{},
      perPage:  20,
      pageNum:1,
      noofpages:'',
      pageOptions: [5, 10, 15],
      sortBy:'',
      pageNum:1,
      editpickuptype:'',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      selectDateTo: new Date(),
       selectDateFrom: new Date(),
    }

  },
   computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
  created: function () {
    this.state();
   // var palletids = JSON.parse(localStorage.getItem("palletid"));
    this.displaydata(this.pageNum);

    
  },

  methods: {
      
        displaydata: function (pagee) {
    

      
    this.isBusy = true;
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
       

      

   

    
      const obj = {
       
         
          limit:"20",
          page_no:pagee,
          statename:this.value6,
          //pickuptype:this.editpickuptype,
          searchFilter:this.searching,
          hub_id:`${userInfo.pickuplocationmasterid}`,
      }
     
     

 
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/readytodispatchlisting`,obj)
        .then((result) => {
          if (result.body.returnmsg === 'successful') {
            
             this.items  = result.body.returnvalue[0].ReadytoDispatchListingInfo;
      
           
             
             this.totalRows =result.body.returnvalue[1].totalrecords[0].count;
             // console.log(this.totalRows)
             this.noofpages=parseInt(this.totalRows)/20;
              this.noofpages=Math.ceil( this.noofpages);
             this.isBusy = !this.isBusy;
             // this.customer.pallet_id='';
             
          } else {
           this.isBusy = !this.isBusy
              this.items=[];   
               
            this.totalRows = 0;
            // Utils.notify("No Records Found",'error');
            this.$fire({
                  text:"No Records Found",
                  type: "error",
                  timer: 30000
                }); 


           
            
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
        




        state: function() {
         
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
       const obj = {
        hub_id:`${userInfo.pickuplocationmasterid}`,
      
      };
     
     
this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getavailablestatenamelisting`,obj)
        .then((result) => {
          this.statenamelist = result.body.returnvalue;
          //console.log("mmmmm"+this.statenamelist.length);
          
          for(var i = 0; i < this.statenamelist.length; i++) {
            var zone2 = {
        name: this.statenamelist[i].pickuplocationstate,
        id: this.statenamelist[i].pickuplocationstate,
      }
      //console.log("mmmmm"+this.statenamelist.length);
 this.stateoptions.push(zone2);

        // this.options.push(this.agentmaster[i].deliveryagentfirstname);
           
       }

        })
        .catch((ex) => {
          console.log('error', ex)
        })
        //console.log(this.stateoptions);
    },
        clear: function() {
        // this.editpickuptype="";
         this.searching="";
      this.customer = {}
      this.value6=[];
      this.displaydata(this.pageNum);
      
    },

   


     clickCallback (pageNum)
       {
         //alert(" i m in pagination task");
      // alert(pageNum)
      this.displaydata(pageNum);
    },
    downloadCSV: function() {
  document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      
const csvObj = {
       
         
          // limit:"20",
          // page_no:pagee,
          statename:this.value6,
          pickuptype:this.editpickuptype,
          searchFilter:this.searching,
          sysusermasterid:`${userInfo.sysusermasterid}`,
          hub_id:`${userInfo.pickuplocationmasterid}`, 
      }
// var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// console.log(csvObj);
   
this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/readytodispatchlistingcsv_advanced`,csvObj)
        .then(result => {
         console.log(result.url);
         document.getElementById("overlay").style.display = "none";
       if(result.body=="success")
         {
         // alert("Please Check Ur Mail For Downlod Link")
           this.$fire({
                  text:"Please Check Ur Mail For Downlod Link",
                  type: "success",
                  timer: 30000
                }); 

       }
       else
       {
        // alert("Can not Download");
        this.$fire({
                  text:"Can not Download",
                  type: "error",
                  timer: 30000
                }); 
       }

       // window.location.href =result.url;
        });
        
    },

// downloadCSV: function() {
 
      
// const csvObj = {
       
         
//           // limit:"20",
//           // page_no:pagee,
//           statename:this.value6,
//          // pickuptype:this.editpickuptype,
//           searchFilter:this.searching,
//       }
// var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// // console.log(queryString);
   
// this.$http.get(`${CONSTANTS.MISREPORT_API_URL}/readytodispatchlistingcsv`+queryString)
//         .then(result => {
//          console.log(result.url);
//         window.location.href =result.url;
//         });
        
//     },

    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
    
    


    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
  }
}
</script>

<style type="text/css">
 .totalback
 {
  background: #c8ced3 !important;
   border-right: 1px solid grey !important;
   max-width: 300px !important;
    
  }

  .hidden_header {
    
  display: none;
}
   .pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  transition: background-color .3s;
  border: 1px solid #ddd;
}


.page-item.active {
  background-color: #87CEEB;
    color: white;
}

.pagination a:hover:not(.active) {background-color: #ddd;}
  
  .bt_group
  {
    position: absolute;
    margin-top: 5px;
  }
  #overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}


/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>
